define('app/sdc/stop/propagation/sdc-stop-propagation-factory',[],function () {
	return function stopPropagation(element, events) {
		unbind.scope = bindToScope;
		element.on(events, handler);
		return unbind;
		function bindToScope(scope) {
			return scope.$on("$destroy", unbind);
		}
		function handler(e) {
			e.stopPropagation();
		}
		function unbind() {
			element.off(events, handler);
		}
	};
});
